
import { supabase } from "@/integrations/supabase/client";
import { EnhancedColorSuggestion } from "./types";

export const fetchAISuggestions = async (term: string): Promise<EnhancedColorSuggestion[]> => {
  if (term.length <= 3) {
    return [];
  }

  try {
    const { data: historicalAnalyses } = await supabase
      .from('color_analysis_history')
      .select('original_input, parsed_product_name, parsed_color_code, predicted_base_color, confidence_score')
      .or(`original_input.ilike.%${term}%,parsed_product_name.ilike.%${term}%,parsed_color_code.ilike.%${term}%`)
      .eq('was_correct', true)
      .order('confidence_score', { ascending: false })
      .limit(8);

    if (historicalAnalyses && historicalAnalyses.length > 0) {
      return historicalAnalyses.map(analysis => ({
        value: analysis.original_input,
        label: `${analysis.parsed_product_name || analysis.original_input} (${analysis.predicted_base_color} basis)`,
        confidence: analysis.confidence_score || 0,
        baseColor: analysis.predicted_base_color
      }));
    }

    return [];
  } catch (error) {
    console.error('Error fetching AI suggestions:', error);
    return [];
  }
};
